module.exports = __webpack_public_path__ + "cdd81e4fa8adff15346be53196b1667e.pdf";